var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon2Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.01 20.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#39af4f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 21.01,
    height: 20.63
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.16,12.92a5.27,5.27,0,1,1,5.27-5.27,5.27,5.27,0,0,1-5.27,5.27m0-9.14A3.87,3.87,0,1,0,13,7.65,3.87,3.87,0,0,0,9.16,3.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.43,20.52a.7.7,0,0,1-.7-.7,4.8,4.8,0,0,0-5-4.56H6.6a4.81,4.81,0,0,0-5,4.56.7.7,0,0,1-1.4,0,6.21,6.21,0,0,1,6.42-6h5.12a6.2,6.2,0,0,1,6.41,6,.7.7,0,0,1-.7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.2,18.26a.71.71,0,0,1-.7-.69,5.19,5.19,0,0,0-3.82-4.76.71.71,0,0,1-.47-.88.7.7,0,0,1,.88-.46,6.58,6.58,0,0,1,4.81,6.08.7.7,0,0,1-.69.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.89,8.14a.64.64,0,0,1-.2,0,.7.7,0,0,1-.47-.87,4.56,4.56,0,0,0-3.59-5.78A.7.7,0,1,1,12.87.08a6,6,0,0,1,4.69,7.56.71.71,0,0,1-.67.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon2Active);
export default __webpack_public_path__ + "static/media/contact-icon2-active.dee8dabcb89e22770987ab2acc4409ff.svg";
export { ForwardRef as ReactComponent };